exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.control-label[data-v-15127d60] {\n  font-weight: 700;\n}\n.overflow-wrap[data-v-15127d60] {\n  overflow-wrap: anywhere;\n  height: fit-content;\n}\n.notes[data-v-15127d60] {\n  border: none;\n  font-family: \"Roboto\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n}\n", ""]);

// exports
